import React from "react";
import PropTypes from "prop-types";

/**
 * Mapping of course states to their display name.
 * @type {{ended: string, cancelled: string, finished: string, open: string}}
 */
export const courseStateNames = [
    {
        slug: "open",
        name: "Open"
    },
    {
        slug: "ended",
        name: "Afgelopen"
    },
    {
        slug: "finished",
        name: "Afgerond"
    },
    {
        slug: "cancelled",
        name: "Geannuleerd"
    }
    // old style:
    // open: 'Open',
    // ended: 'Afgelopen',
    // finished: 'Afgerond',
    // cancelled: 'Geannuleerd',
];

/**
 * The display name of the specified course state.
 * @param {String} state
 * @returns {JSX.Element}
 */
export function CourseStateName({ state }) {
    return <>{courseStateNames?.find((item) => item.slug === state)?.name || state}</>;
}
CourseStateName.propTypes = {
    state: PropTypes.string
};
